import {
  Condition,
  MetafieldMatchType,
} from "@redotech/redo-model/return-flow/condition";
import {
  productVariantMetafieldFromModel,
  validateProductVariantMetafieldCondition,
  type ProductVariantMetafieldState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_VARIANT_METAFIELD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductVariantMetafieldState>
  >,
): ConditionType<
  ProductVariantMetafieldState,
  Condition.ProductVariantMetafield
> => ({
  name: "Product variant metafield",
  description(state) {
    return `Metafield: ${state.namespace}.${state.key}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductVariantMetafieldState>) {
    return React.createElement(Details, props);
  },
  empty: {
    namespace: "",
    key: "",
    comparison: MetafieldMatchType.EXACT,
    value: "",
  },
  fromModel(model: Condition.ProductVariantMetafield) {
    return productVariantMetafieldFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_VARIANT_METAFIELD, ...state };
  },
  valid(state) {
    return validateProductVariantMetafieldCondition(state).valid;
  },
});

export { type ProductVariantMetafieldState } from "@redotech/redo-model/return-flow/condition-validate";
